/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failedtologinpleasecheckyourcredentials6Inputs */

const en_failedtologinpleasecheckyourcredentials6 = /** @type {(inputs: Failedtologinpleasecheckyourcredentials6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to login. Please check your credentials.`)
};

const de_failedtologinpleasecheckyourcredentials6 = /** @type {(inputs: Failedtologinpleasecheckyourcredentials6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldung fehlgeschlagen. Prüf deine E-Mail und dein Passwort.`)
};

/**
* | output |
* | --- |
* | "Failed to login. Please check your credentials." |
*
* @param {Failedtologinpleasecheckyourcredentials6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const failedtologinpleasecheckyourcredentials6 = /** @type {((inputs?: Failedtologinpleasecheckyourcredentials6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failedtologinpleasecheckyourcredentials6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_failedtologinpleasecheckyourcredentials6(inputs)
	return de_failedtologinpleasecheckyourcredentials6(inputs)
});
export { failedtologinpleasecheckyourcredentials6 as "failedToLoginPleaseCheckYourCredentials" }